import React from 'react'
import * as S from './CatalogGroupList.styled'
import { useRouter } from 'next/router'
import MobileRowItem from '../../mobileShared/MobileRowItem/MobileRowItem'

const CatalogGroupList = ({ children }) => {
    const router = useRouter()
    return (
        <S.Container>
            {children.map((x) => (
                <MobileRowItem
                    key={x.groupId}
                    aProps={{
                        'data-catalog-id': x.groupId
                    }}
                    data-catalog-id={x.groupId}
                    linkUrl={`${router.asPath}/${x.groupId}`}
                    isLink
                    isShowedRow>
                    {x.groupTitle}
                </MobileRowItem>
            ))}
        </S.Container>
    )
}

CatalogGroupList.propTypes = {}

export default CatalogGroupList
